import { render } from "./ChooseManufacture.vue?vue&type=template&id=574389cb"
import script from "./ChooseManufacture.vue?vue&type=script&lang=js"
export * from "./ChooseManufacture.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__